(function () {
  if (window.__zinusRebuyPdpAtcGateBooted) return;
  window.__zinusRebuyPdpAtcGateBooted = true;

  const ZINUS_REBUY_PENDING_ATC = 'zinus-rebuy-pending-atc';
  const ZINUS_REBUY_READY_EVENTS = [
    'rebuy.loaded',
    'rebuy:smartcart.ready',
    'rebuy:cart.ready',
    'rebuy.ready',
  ];

  function rebuyRuntimeLooksReady() {
    try {
      const rebuy = window.Rebuy;
      if (!rebuy || typeof rebuy !== 'object') return false;
      if (typeof rebuy.SmartCart?.show === 'function' || typeof rebuy.SmartCart?.open === 'function') {
        return true;
      }
      if (rebuy.Cart && typeof rebuy.Cart.cart === 'function') return true;
      if (Array.isArray(rebuy.widgets) && rebuy.widgets.length > 0) return true;
    } catch (e) {}
    return false;
  }

  function initZinusPdpRebuyAtcGate() {
    const pdpAtcRoot = document.querySelector('.product_add_to_cart-button');
    const upsellButtons = Array.from(document.querySelectorAll('.upsell-popup__button'));
    if (!pdpAtcRoot && !upsellButtons.length) return;

    let settled = false;
    let fallbackTimer = null;
    const observers = [];

    const stopObserving = () => {
      while (observers.length) {
        observers.pop().disconnect();
      }
    };

    const releasePending = () => {
      if (settled) return;
      settled = true;
      if (fallbackTimer != null) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
      document.querySelectorAll('.' + ZINUS_REBUY_PENDING_ATC).forEach((el) => {
        el.classList.remove(ZINUS_REBUY_PENDING_ATC);
      });
      stopObserving();
    };

    const syncPending = () => {
      if (settled) return;

      upsellButtons.forEach((btn) => {
        const showUpsell = !btn.classList.contains('hidden');
        btn.classList.toggle(ZINUS_REBUY_PENDING_ATC, showUpsell);
      });

      if (!pdpAtcRoot) return;

      const row = pdpAtcRoot.querySelector('.product__submit__item');
      const rowShown = row && !row.classList.contains('hidden');
      const activeSubmit = pdpAtcRoot.querySelector('.product__submit__add.actived');
      const submitButtons = pdpAtcRoot.querySelectorAll('button.product__submit__add[data-add-to-cart]');
      const hasAtcNotifyPair = pdpAtcRoot.querySelector('.product__submit__add.atc-button');

      submitButtons.forEach((btn) => {
        let isTracked;
        if (activeSubmit) {
          isTracked = btn === activeSubmit;
        } else if (hasAtcNotifyPair) {
          isTracked = btn.classList.contains('atc-button');
        } else {
          isTracked = !btn.classList.contains('hidden');
        }
        btn.classList.toggle(ZINUS_REBUY_PENDING_ATC, Boolean(rowShown && isTracked));
      });

      const decoyAtc = document.querySelector('button.product__submit__add.custom_add-button');
      if (decoyAtc) {
        const anySubmitPending = pdpAtcRoot.querySelector(
          'button.product__submit__add.' + ZINUS_REBUY_PENDING_ATC
        );
        decoyAtc.classList.toggle(ZINUS_REBUY_PENDING_ATC, Boolean(anySubmitPending));
      }
    };

    const observe = (node, options) => {
      const o = new MutationObserver(syncPending);
      o.observe(node, options);
      observers.push(o);
    };

    ZINUS_REBUY_READY_EVENTS.forEach((name) => {
      document.addEventListener(name, releasePending, { once: true });
    });
    window.addEventListener('SecuvyConsentStatus', releaseOnConsentChange);

    // Force release if Rebuy never loads (ad blocker / CMP rejection / CDN outage)
    const MAX_WAIT_MS = 4000;
    fallbackTimer = setTimeout(releasePending, MAX_WAIT_MS);

    queueMicrotask(() => {
      if (rebuyRuntimeLooksReady()) releasePending();
    });
    requestAnimationFrame(() => {
      if (rebuyRuntimeLooksReady()) releasePending();
    });

    if (pdpAtcRoot) {
      observe(pdpAtcRoot, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });
    }

    upsellButtons.forEach((btn) => {
      if (pdpAtcRoot && pdpAtcRoot.contains(btn)) return;
      observe(btn, { attributes: true, attributeFilter: ['class'] });
    });

    syncPending();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZinusPdpRebuyAtcGate);
  } else {
    initZinusPdpRebuyAtcGate();
  }
})();
